import { ProjectBranch } from './branch';
import {  FileChecksum } from './filechecksum';
import { PageRequest } from '../pageRequest';
import { PageResponse } from '../pageResponse';

export interface Transaction {
    id?: string;
    status?: string;
    branch?: ProjectBranch;
    oetkTransactionId?: string;
    packageId?: string;
    versionCode?: string;
    versionName?: string;
    fileChecksums?: FileChecksum[];
    creationDate?: Date;
    modifyDate?: Date;
}

export class ImportTransactionRequest {
    constructor(public projectId: string,
        public branchId: string,
        public transactionId: string) {}
}


export class ImportTransactionResponse {
    constructor(public status: string,
        public creationDate: Date,
        public modifyDate: Date) {}
}
